import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    searchParameter['moduleId'] = parameter;
  }
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    defaultFormData['moduleId'] = parameter;
  }
  pageComponent.setState({ defaultFormData });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
  }, config.setTimeoutMilliSecond);
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
        //处理不适合antd组件的数据
        let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
        sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
          group.uieList.forEach(uie => {
            switch (uie.component) {
              case 'Select':
                //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                if (data.data[uie.source] === null && componentDataSource[uie.source] !== undefined) {
                  data.data[uie.source] = componentDataSource[uie.source][0].Value;
                }
                break;
            }
          });
        });
        // //处理AssignedUserId
        // switch (data.data.AssignedToRole) {
        //   case 'Assessing User':
        //     data.data.AssignedUserId = -3;
        //     break;
        //   case 'Assigned User':
        //     data.data.AssignedUserId = -2;
        //     break;
        //   case 'Signoff User':
        //     data.data.AssignedUserId = -1;
        //     break;
        // }
        //把处理后的数据赋值给表单
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
        sectionComponent.customForm.current?.setState({ formData: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();

  switch (form.AssignedUserId) {
    case -3:
      form.AssignedToRole = 'Assessing User';
      form.AssignedUserId = null;
      break;
    case -2:
      form.AssignedToRole = 'Assigned User';
      form.AssignedUserId = null;
      break;
    case -1:
      form.AssignedToRole = 'Signoff User';
      form.AssignedUserId = null;
      break;
     case -4:
      form.AssignedToRole = 'Current User';
      form.AssignedUserId = null;
      break; 
    default:
      if (form.AssignedStaffID > 0) {
        form.AssignedToRole = null;
      }
      break;
  }

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }
  form.key = formComponent.state.currentDataKey;

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish(formComponent, sectionComponent);
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish(formComponent, sectionComponent);
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ customFormSubmitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

//添加或修改完成，处理后续重置按钮或刷新Section等事宜
function customFormFinish(formComponent, sectionComponent) {
  sectionComponent.setState({ showModal: false, componentType: null, customFormSubmitting: false });
  setTimeout(() => {
    formComponent.resetFields();
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//通过 Favorite 修改 icon
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Favorite) {
      //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
      iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  return data;
}

export function formatGroupData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let dataItem = item.DataList.map((item, i) => {
      let iconFormat = [];
      if (item.Favorite) {
        //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
        iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
      }
      if (iconFormat.length > 0) item.IconFormat = iconFormat;
      return item;
    })
    item.DataList = dataItem
  })
  return data;
}

//更新 Favorite 状态
export function updateFavorite({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .put('Admin/TaskTemplate/UpdateFavorite', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function addTaskTemplatePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie });
}

export function editTaskTemplatePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie });
}

function setGroupNameDataSource({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let options = [];
  sectionComponent.child?.current?.state.data.map((item, i) => {
    if (item.key !== 0) {
      options.push({ label: item.Name, value: item.Name });
    }
  })

  setTimeout(() => {
    let componentDataSource = { ...sectionComponent.customForm.current.state.componentDataSource };
    componentDataSource['GroupName'] = options;
    sectionComponent.customForm.current.setState({ componentDataSource });
  }, config.setTimeoutMilliSecond);
}

// export function cancelCustomForm({ parameter, sectionComponent, pageComponent, uie } = {}) {
//   sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
//   setTimeout(() => {
//     sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
//     sectionComponent.customForm.current?.resetFields();
//   }, config.setTimeoutMilliSecond);
// }